/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';
import { first, isNumber, isBoolean } from 'lodash';
import cardPool from '@/config/card-pool';
import Board from '@/models/Board';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    moves: 0,
    hasWon: false,
    hasLost: false,
    board: null,
    boardSize: 4,
    allowedBoardSizes: [2, 4, 6, 8],
  },
  getters: {
    moves: state => state.moves,
    hasWon: state => state.hasWon,
    hasLost: state => state.hasLost,
    board: state => state.board,
    boardSize: state => state.boardSize,
    numberOfCards: state => (state.boardSize * state.boardSize),
    numberOfCardTypes: state => ((state.boardSize * state.boardSize) / 2),
    allowedBoardSizes: state => state.allowedBoardSizes,
  },
  mutations: {
    setMoves: (state, payload) => {
      state.moves = isNumber(payload) ? payload : state.moves;
    },
    setHasWon: (state, payload) => {
      state.hasWon = isBoolean(payload) ? payload : state.hasWon;
    },
    setHasLost: (state, payload) => {
      state.hasLost = isBoolean(payload) ? payload : state.hasLost;
    },
    setBoard(state, payload) {
      state.board = (payload === null || payload instanceof Board) ? payload : state.board;
    },
    setBoardSize(state, payload) {
      state.boardSize =
        isNumber(payload) && (state.allowedBoardSizes.indexOf(payload) === -1)
          ? first(state.allowedBoardSizes)
          : payload;
    },
  },
  actions: {
    incrementMoves(context) {
      const { getters, commit } = context;
      commit('setMoves', getters.moves + 1);
    },
    startGame(context) {
      const { getters, commit } = context;
      const size = getters.boardSize;
      const board = new Board(size, cardPool);

      commit('setBoard', board);
      commit('setMoves', 0);
      commit('setHasWon', false);
      commit('setHasLost', false);
    },
    winGame(context) {
      setTimeout(() => {
        context.commit('setHasWon', true);
      }, 2000);
    },
    loseGame(context) {
      context.commit('setHasLost', true);
    },
    endGame(context) {
      const { commit } = context;

      commit('setBoard', null);
      commit('setMoves', 0);
      commit('setHasWon', false);
      commit('setHasLost', false);
    },
  },
});
